import { LoginForm } from "@/features/auth/login";
import { loginReasonMessage, validateLoginSearch } from "@/features/auth/login-search";
import { restoreTarget } from "@/features/auth/redirect";
import { createFileRoute, useRouter } from "@tanstack/react-router";

export const Route = createFileRoute("/login")({
  validateSearch: validateLoginSearch,
  component: LoginPage,
});

function LoginPage() {
  const router = useRouter();
  const { reason, redirect } = Route.useSearch();
  const notice = loginReasonMessage(reason);
  // IR-1288: restoreTarget re-sanitises (validateLoginSearch does too, but not
  // reliably on an initial deep-link — see redirect.ts) and falls back to
  // Overview. The target is a full href (path + query + hash), so it goes
  // through history rather than `navigate({ to })`, which expects a bare path.
  // `replace` keeps /login out of the back stack.
  const restore = () => router.history.replace(restoreTarget(redirect));
  return (
    <div className="flex min-h-[70vh] items-center justify-center">
      <div className="iris-card w-full max-w-md" style={{ padding: 24 }}>
        <h1
          className="mb-6 text-2xl font-semibold tracking-tight"
          style={{ fontFamily: "var(--iris-font-display)", color: "var(--iris-fg-1)" }}
        >
          Sign in to Iris Ops
        </h1>
        {notice && (
          <output
            className="iris-meta mb-4"
            style={{
              display: "block",
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid var(--iris-neon-amber, #d9a441)",
              color: "var(--iris-fg-2)",
              background: "color-mix(in srgb, var(--iris-neon-amber, #d9a441) 12%, transparent)",
            }}
          >
            {notice}
          </output>
        )}
        <LoginForm onSuccess={restore} />
      </div>
    </div>
  );
}
